import { action, observable } from 'mobx';
import { ProjectDataObject } from '../Projects/projectsLibrary';

export class ProjectsStore {
  constructor(private appStore: any) {
    this.init();
  }
  @observable currentProject!: ProjectDataObject;
  @observable currentProjectId;
  @observable currentSessionId;
  @observable currentGpSessionId;
  @observable soilErrors;
  @observable landErrors;

  @action reset() {
    this.init();
  }

  @action init() {
    this.currentProject = {
      projectUuid: '',
      projectionText:'',
      projectTitle: '',
      sessionList: [],
      createdBy: '',
      projectClassType: '',
      projectStatusId: 0,
      createdDate: '',
      lastChangedDate: '',

      client: '',
      practice: '',
      state: '',
      county: '',
      comment: '',

      projectStatusTypeId: 0,
      srid: 123,
      zUnits: 0,
      xmin: 0,
      xmax: 0,
      ymin: 0,
      ymax: 0,
      projectOwnerId: 1,
      projectStatusUpdatedBy: 1,

      projectApplicationUser: '',
      projectClassId: 0,
      designStartDate: '',
      designFinishDate: '',
      designProjectApproveDate: '',
      designProjectApprover: '',
      geometryId: 0,
      referenceProjectUuid: '',
      farmlandId: 0,
      projectStatus: '',
      alfrescoDocumentId: '',
      creationDate: '',
      lastChangeDate: '',
      lastChangedBy: '',
      dataSources: [
        {
          dataSourceTypeName: '',
          creationDate: '',
          lastChangeDate: '',
          lastChangedBy: '',
        },
      ],
      session: {
        sessionUuid: '',
        projectUuid: '',
        sessionCreationDate: '',
        sessionFinishDate: '',
        stepCodeName: '',
        stagingWorksSpacePath: '',
        stagingDataCleaningStatus: '',
        noticeToUser: true,
        noticeToClean: true,
        creationDate: '',
        lastChangedBy: '',
        lastChangeDate: '',
        note: '',
      },
      userpreference:
        '{ "firstPreference" : "firstPreferenceValue", "secondPreference" : "secondePreferenceValue", "thirdPreference" : "[thirdPreferenceValue1,thirdPreferenceValue2, thirdPreferenceValue3]"}',
    };
    this.currentProjectId = '';
    this.currentSessionId = '';
    this.currentGpSessionId = '';
    this.soilErrors = false;
    this.landErrors = false;
  }
}
